import { useMemo } from "react";
import { Modal, Row, Col, Select, Divider, Input, List, Button, Checkbox, Typography } from "antd";
import { sendBillAction } from "../action/SendBillAction";
import { v4 as uuidv4 } from "uuid";

const { TextArea, Search } = Input;
const { Text } = Typography;

const sizeOrder = [
  { label: "Small (S)", value: "S" },
  { label: "Medium (M)", value: "M" },
  { label: "Large (L)", value: "L" },
];

const SugarAndIceOptions = [
  { label: "0%", value: "0%" },
  { label: "30%", value: "30%" },
  { label: "50%", value: "50%" },
  { label: "70%", value: "70%" },
  { label: "100%", value: "100%" },
];

const CustomizeOrder = ({
  open,
  item,
  toppings,
  selectedToppings,
  setSelectedToppings,
  size,
  setSize,
  sugar,
  setSugar,
  ice,
  setIce,
  note,
  setNote,
  searchTerm,
  setSearchTerm,
  onCancel,
  setOpen,
  editMode
}) => {
  const filteredToppings = useMemo(() => {
    const q = searchTerm.trim().toLowerCase();
    if (!q) return toppings;
    return toppings.filter((t) => t.name.toLowerCase().includes(q));
  }, [toppings, searchTerm]);

  const handleToggleTopping = (topping) => {
    setSelectedToppings((prev) => {
      const exists = prev.some((t) => t.id === topping.id);
      if (exists) {
        return prev.filter((t) => t.id !== topping.id);
      }
      return [...prev, { ...topping, quantity: 1 }];
    });
  };

  const increaseToppingQuantity = (toppingId) => {
    setSelectedToppings((prev) =>
      prev.map((t) =>
        t.id === toppingId ? { ...t, quantity: t.quantity + 1 } : t
      )
    );
  };

  const decreaseToppingQuantity = (toppingId) => {
    setSelectedToppings((prev) =>
      prev
        .map((t) =>
          t.id === toppingId ? { ...t, quantity: Math.max(1, t.quantity - 1) } : t
        )
    );
  };

  const handleSubmitConfirm = () => {

    if (editMode === false) {
      sendBillAction("add-item", {
        ...item,
        quantity: 1,
        customize: uuidv4(),
        size,
        sugar,
        ice,
        toppings: [...selectedToppings],
        note,
      });
      setOpen(false);
    }
    else {
      sendBillAction("edit-item", {
        ...item,
        customize: item.customize,
        size,
        sugar,
        ice,
        toppings: [...selectedToppings],
        note,
      });
      setOpen(false);
    }

  }



  return (
    <Modal
      title={<Text strong style={{ fontSize: "18px" }}>☕ Customize {item?.name || ""}</Text>}
      open={open}
      onCancel={onCancel}
      onOk={handleSubmitConfirm}
      okText="Add to Order"
      width={500}
      style={{ top: "5%" }}
    >
      {/* Options */}
      <Row gutter={[16, 12]}>
        <Col span={12}>
          <Text strong>Size</Text>
          <Select
            value={size}
            onChange={(value) => setSize(value)}
            style={{ width: "100%", marginTop: 6 }}
            options={sizeOrder}
          />
        </Col>

        <Col span={12}>
          <Text strong>Sugar</Text>
          <Select
            value={sugar}
            onChange={(value) => setSugar(value)}
            style={{ width: "100%", marginTop: 6 }}
            options={SugarAndIceOptions}
          />
        </Col>

        <Col span={12}>
          <Text strong>Ice</Text>
          <Select
            value={ice}
            onChange={(value) => setIce(value)}
            style={{ width: "100%", marginTop: 6 }}
            options={SugarAndIceOptions}
          />
        </Col>

        <Col span={12}>
          <Text strong>Note</Text>
          <TextArea
            rows={1}
            placeholder="Add special instructions..."
            value={note}
            onChange={(e) => setNote(e.target.value)}
            style={{ marginTop: 6 }}
          />
        </Col>
      </Row>

      <Divider orientation="left" style={{ marginTop: 12 }}>
        Add Toppings
      </Divider>

      <Row style={{ marginBottom: 8 }}>
        <Col span={24}>
          <Search
            placeholder="Search topping..."
            allowClear
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Col>
      </Row>

      <div
        style={{
          maxHeight: 300,
          overflowY: "auto",
          padding: 8,
          border: "1px solid #f0f0f0",
          borderRadius: 8,
          background: "#fff",
        }}
      >
        <List
          dataSource={filteredToppings}
          renderItem={(topping) => {
            const selected = selectedToppings.find((t) => t.id === topping.id);

            const checked = !!selected;
            return (
              <List.Item
                key={topping.id}
                style={{
                  padding: "8px 12px",
                  borderRadius: 8,
                  background: "#fafafa",
                  marginBottom: 8,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 12, width: "60%" }}>
                  <img
                    src={topping.img}
                    alt={topping.name}
                    width={44}
                    height={44}
                    style={{ borderRadius: 6, objectFit: "cover" }}
                  />
                  <div>
                    <Text strong>{topping.name}</Text>
                    <div>
                      <Text type="secondary">${topping.price.toFixed(2)}</Text>
                    </div>
                  </div>
                </div>

                {checked && (
                  <div className="counter">
                    <Button
                      size="small"
                      className="counter-btn"
                      onClick={() => decreaseToppingQuantity(topping.id)}
                    >
                      <span style={{marignTop:"-2px"}}>-</span>
                      
                    </Button>
                    <span className="counter-value" style={{marginLeft:"10px"}}>{selected.quantity}</span>
                    <Button
                      size="small"
                      className="counter-btn"
                      onClick={() => increaseToppingQuantity(topping.id)} 
                    >
                      <span style={{marginTop:"-2px"}}>+</span>
                    </Button>
                  </div>
                )}

                <Checkbox
                  className="circle-checkbox"
                  checked={checked}
                  onChange={() => handleToggleTopping(topping)}
                  style={{ transform: "scale(1.5)" }}
                />
              </List.Item>
            );
          }}
        />
      </div>
    </Modal>
  );
};

export default CustomizeOrder;
